module.exports = __webpack_public_path__ + "assets/img/added_child_item.b897dad8.png";